import React from "react";
import { FaLinkedin, FaPlus } from "react-icons/fa";

const Team: React.FC = () => {
  return (
    <section className="max-w-6xl mx-auto py-12 px-4">
      <h1 className="text-3xl md:text-4xl font-extrabold text-blue-800 mb-6">Our Team</h1>
      <p className="text-gray-700 mb-8 max-w-3xl">Upload photos and add LinkedIn bios for each team member. Use the placeholders below to get started. You can add more members anytime.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1,2,3].map((i) => (
          <div key={i} className="bg-white rounded-xl shadow p-6 flex flex-col items-center text-center">
            <div className="w-28 h-28 rounded-full bg-gray-100 flex items-center justify-center mb-4 overflow-hidden">
              <button className="text-gray-500 hover:text-blue-600 flex items-center gap-2">
                <FaPlus /> Upload Photo
              </button>
            </div>
            <input type="text" placeholder="Full Name" className="w-full border rounded px-3 py-2 mb-2" />
            <input type="text" placeholder="Role / Title" className="w-full border rounded px-3 py-2 mb-2" />
            <textarea placeholder="Short bio" className="w-full border rounded px-3 py-2 mb-3 min-h-[80px]"></textarea>
            <div className="w-full flex items-center gap-2">
              <FaLinkedin className="text-blue-700" />
              <input type="url" placeholder="LinkedIn profile URL" className="flex-1 border rounded px-3 py-2" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Team;
